import { useEffect, useState } from "react";
import { supabase } from "../lib/supabase";

const GoogleCalendarCallback = () => {
  const [status, setStatus] = useState<"loading" | "success" | "error">("loading");
  const [errorMessage, setErrorMessage] = useState("");

  useEffect(() => {
    const exchangeCode = async () => {
      const params = new URLSearchParams(window.location.search);
      const code = params.get("code");
      const state = params.get("state");
      const errorParam = params.get("error");

      if (errorParam) {
        setStatus("error");
        setErrorMessage(errorParam === "access_denied" ? "Access was denied." : errorParam);
        return;
      }

      if (!code || !state) {
        setStatus("error");
        setErrorMessage("Missing authorization code or state parameter.");
        return;
      }

      const { error } = await supabase.functions.invoke("google-calendar-auth", {
        body: { action: "exchange-code", code, state },
      });

      if (error) {
        setStatus("error");
        setErrorMessage("Failed to connect Google Calendar. Please try again.");
        return;
      }

      setStatus("success");

      // Notify the opener window
      if (window.opener) {
        window.opener.postMessage({ type: "google-calendar-connected" }, "*");
      }

      // Close popup after a short delay
      setTimeout(() => window.close(), 1500);
    };

    exchangeCode();
  }, []);

  return (
    <div className="min-h-screen bg-warm-bg-base flex items-center justify-center">
      <div className="bg-warm-bg-card rounded-card border border-warm-border shadow-soft-md p-12 w-full max-w-md h-80 flex flex-col items-center justify-center text-center">
        {status === "loading" && (
          <>
            <div
              className="loader-rings mb-8"
              style={{ fontSize: "12px" }}
              aria-hidden="true"
            >
              {Array.from({ length: 5 }, (_, i) => (
                <div key={i} className={`loader-ring loader-ring-${i + 1}`} />
              ))}
            </div>
            <p className="text-warm-text-secondary">Connecting Google Calendar...</p>
          </>
        )}

        {status === "success" && (
          <>
            <div className="text-4xl mb-4">&#10003;</div>
            <p className="text-warm-text-primary font-medium">Connected!</p>
            <p className="text-sm text-warm-text-tertiary mt-1">
              This window will close automatically.
            </p>
          </>
        )}

        {status === "error" && (
          <>
            <div className="text-4xl mb-4">&#10007;</div>
            <p className="text-warm-text-primary font-medium">Connection Failed</p>
            <p className="text-sm text-red-500 mt-1">{errorMessage}</p>
            <button
              onClick={() => window.close()}
              className="mt-4 px-4 py-2 text-sm font-medium text-white bg-warm-blue hover:bg-warm-blue-dark rounded-lg transition-colors"
            >
              Close
            </button>
          </>
        )}
      </div>
    </div>
  );
};

export default GoogleCalendarCallback;
